import { Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../i18n/language.service';

/**
 * Spezifische Pipe-Implementierung um Prozentwerte gemäß der gewählten Sprache des Nutzers zu formatieren
 * wobei der Wert mit 100 multipliziert wird und das Prozentzeichen als Symbol hinzugefügt wird.
 * Zusätzlich kann ein optionaler Suffix übergeben werden.
 *
 * Die Angabe der Formatierung erfolg analog der"offiziellen" Angular2-Logik (Auszug). Zusätzlich kann ein Suffix mit übergeben werden:
 *
 *   digitInfo is a string which has a following format:
 *   {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}
 *       minIntegerDigits is the minimum number of integer digits to use. Defaults to 1.
 *       minFractionDigits is the minimum number of digits after fraction. Defaults to 0.
 *       maxFractionDigits is the maximum number of digits after fraction. Defaults to 3.
 *
 *  Beispiele
 *  - customPercent:'1.2-2'                    Formatiert den Wert auf 2 Nachkommastellen, z.B. 123,56
 *  - customPercent:'1.1-1':'(indikativ)'      Formatiert den Wert auf 1 Nachkommastelle und fügt den Suffix hinzu, z.B. 123,5 % (indikativ)
 *
 * @author: mgru
 */
@Pipe({
    name: 'customPercent'
})
export class CustomPercentPipe implements PipeTransform {

    private languageSubscription: Subscription;

    constructor(private languageService: LanguageService) {
    }

    transform(value: string, format: string = '1.0-3', suffix: string = '',
              useGrouping: boolean = true, useSymbol: boolean = true): string {

        if (!value) {
            return value;
        }

        const minimumIntegerDigits = parseFloat(format.split('.')[0]);
        const minimumFractionDigits = parseFloat(format.split('.')[1]);
        const maximumFractionDigits = parseFloat(format.split('-')[1]);
        const options = {
            minimumIntegerDigits: minimumIntegerDigits,
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits,
            useGrouping: useGrouping
        };

        const exp = parseFloat(value) * 100;

        if (useSymbol) {
            if (suffix) {
                return exp.toLocaleString(this.languageService.currentLanguage, options) + ' % ' + suffix;
            } else {
                return exp.toLocaleString(this.languageService.currentLanguage, options) + ' %';
            }
        } else {
            if (suffix) {
                return exp.toLocaleString(this.languageService.currentLanguage, options) + suffix;
            } else {
                return exp.toLocaleString(this.languageService.currentLanguage, options);
            }
        }
    }

    ngOnDestroy() {
        if (this.languageSubscription) this.languageSubscription.unsubscribe();
    }
}
